import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import ProfileEditNotesPage from '/component/partial/profile/ProfileEditNotesPage';
import {CANDIDATE_NOTES_STATE_IS_LOADING} from '/enum/candidates.enum';
import {USER_TYPES} from '/enum/tealium.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {
  setCandidateNotesState,
  updateCandidateNotes,
} from '/redux/action/candidate.action';
import {
  notesById,
  notesUpdatedTsById,
} from '/redux/selector/candidate.selector';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withHOC} from '/util/hoc.util';
import {fromProps, withProps} from '/util/selector.util';
const withCandidateId = withProps({
  candidateId: fromProps(get('recordId')),
});

export default withHOC(
  connect(
    createStructuredSelector({
      notes: withCandidateId(notesById),
      notesUpdatedTs: withCandidateId(notesUpdatedTsById),
      userId,
      lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
      coachHighestRank: withProps({coachId: userId})(
        highestAchievedRankDescriptionById,
      ),
      coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
    }),
    dispatch => ({
      updateCandidateNotes: ({candidateId, body}: any) =>
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        dispatch(updateCandidateNotes({candidateId, body})),
      setCandidateNotesState: ({candidateId, stateName, stateValue}: any) =>
        dispatch(
          // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
          setCandidateNotesState({
            candidateId,
            stateName,
            stateValue,
          }),
        ),
    }),
    (stateProps, dispatchProps, ownProps) => {
      const {recordId: candidateId, isReferralProfile} = ownProps;
      const {userId, coachHighestRank, coachCurrentRank} = stateProps;

      return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        userType: isReferralProfile
          ? USER_TYPES.candidateReferral
          : USER_TYPES.candidate,
        coachId: String(userId || 'na'),
        coachHighestRank: coachHighestRank || 'na',
        coachCurrentRank: coachCurrentRank || 'na',
        updateNotes: ({body}: any) => {
          return dispatchProps.updateCandidateNotes({candidateId, body});
        },
        setState: () => {
          return dispatchProps.setCandidateNotesState({
            candidateId,
            stateName: CANDIDATE_NOTES_STATE_IS_LOADING,
            stateValue: true,
          });
        },
      };
    },
  ),
  withTranslation('screen.candidateProfile.section.editNotes'),
)(ProfileEditNotesPage);
